import AlertMui from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

export const Alert = styled(AlertMui)(({theme}) => ({
  borderRadius: 0,
  color: theme.palette.warning.contrastText,
  backgroundColor: theme.palette.warning.main,
  textAlign: 'center',
  paddingLeft: 56,
  '.MuiAlert-message': {
    width: '100%',
    fontWeight: 400,
  },
  'a': {
    color: theme.palette.warning.contrastText,
    fontSize: 'inherit',
  },
}))

export const CloseButton = styled(IconButton)({
  padding: 0,
  '.MuiSvgIcon-root': {
    width: 26,
    height: 26,
    color: '#000',
  },
})
